import BossTimer from '../boss-timer/BossTimer';

const EVENTS = {
    BOSS_SKIP_PRESSED: 'boss_skip_pressed',
};

export default class BossSkip extends Phaser.GameObjects.Sprite {
    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.centerX;
        let y = scene.cameras.main.centerY - 400;
        let frame = 'gui/boss_skip/btn_skip';
        super(scene, x, y, 'atlas', frame);

        this.setInteractive({ useHandCursor: true });
        this.on('pointerdown', () => {
            this.scene.events.emit(EVENTS.BOSS_SKIP_PRESSED);
            this.hide();
        });

        this.setupListeners();
        this.hide();
    }

    static get EVENTS() {
        return EVENTS;
    }

    show() {
        this.setVisible(true);
        this.setActive(true);
    }

    hide() {
        this.setVisible(false);
        this.setActive(false);
    }

    setupListeners() {
        this.scene.events.on(BossTimer.EVENTS.START, this.show, this);
        this.scene.events.on(BossTimer.EVENTS.STOP, this.hide, this);
        this.scene.events.on(BossTimer.EVENTS.EXPIRED, this.hide, this);
    }

    destroy() {
        this.scene.events.off(BossTimer.EVENTS.START, this.show, this);
        this.scene.events.off(BossTimer.EVENTS.STOP, this.hide, this);
        this.scene.events.off(BossTimer.EVENTS.EXPIRED, this.hide, this);

        super.destroy();
    }
}
